import React from "react";
import styled from "styled-components";
import useSelect from "../hooks/useSelect";
import ResultComponent from "./ResultComponent";
import { CloseIcon, Container, Desc, Question, Wrapper } from "./styled";

interface Props {
  setScreen: React.Dispatch<React.SetStateAction<string>>;
}

const Stage3 = ({ setScreen }: Props) => {
  const ANSWER = 4;
  const { select, onClickItem } = useSelect(ANSWER);

  return (
    <Container>
      <Question>
        다음 중 팬덤 이름이 <br />
        아닌 것을 고르시오.
      </Question>

      <AnswerContainer>
        <Wrapper onClick={() => onClickItem(1)} $incorrect={select === 1}>
          <Text>⓵ 스테이</Text>
          {select === 1 && <CloseIcon />}
        </Wrapper>
        <Wrapper onClick={() => onClickItem(2)} $incorrect={select === 2}>
          <Text>⓶ 모아</Text>
          {select === 2 && <CloseIcon />}
        </Wrapper>
        <Wrapper onClick={() => onClickItem(3)} $incorrect={select === 3}>
          <Text>⓷ 캐럿</Text>
          {select === 3 && <CloseIcon />}
        </Wrapper>
        <Wrapper onClick={() => onClickItem(4)} $correct={!!select}>
          <Text>⓸ 아크로</Text>
        </Wrapper>
        <Wrapper onClick={() => onClickItem(5)} $incorrect={select === 5}>
          <Text>⓹ 아미</Text>
          {select === 5 && <CloseIcon />}
        </Wrapper>
        <Wrapper onClick={() => onClickItem(6)} $incorrect={select === 6}>
          <Text>⓺ 다이브</Text>
          {select === 6 && <CloseIcon />}
        </Wrapper>
      </AnswerContainer>

      {!!select && (
        <ResultComponent
          select={select}
          answer={ANSWER}
          nextStage={4}
          setScreen={setScreen}
          desc={
            <Desc>
              1. 스테이 - Stray Kids의 공식 팬클럽
              <br />
              2. 모아 - 투모로우바이투게더의 공식 팬클럽
              <br />
              3. 케럿 - 세븐틴의 공식 팬클럽
              <br />
              5. 아미 - 방탄소년단의 공식 팬클럽
              <br />
              6. 다이브 - IVE의 공식 팬클럽
              <br />
            </Desc>
          }
        />
      )}
    </Container>
  );
};

export default Stage3;

const AnswerContainer = styled.div``;

const Text = styled.div`
  font-size: 30px;
`;
